// extracted by mini-css-extract-plugin
export var avatarWrapper = "post-metadata-module--avatarWrapper--b3e18";
export var dot = "post-metadata-module--dot--75953";
export var metadata = "post-metadata-module--metadata--fd6f8";